var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1334",
    d: "M14.6667 7.99996C14.6667 4.31806 11.6819 1.33329 8.00001 1.33329C4.31811 1.33329 1.33334 4.31806 1.33334 7.99996C1.33334 11.6819 4.31811 14.6666 8.00001 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99996Z",
    stroke: "#97979A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2612",
    d: "M8.16148 11.3333V7.99998C8.16148 7.68571 8.16148 7.52858 8.06385 7.43094C7.96622 7.33331 7.80908 7.33331 7.49481 7.33331",
    stroke: "#97979A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99468 5.33331H8.00067",
    stroke: "#97979A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.b40600f47e7f8066eee0f061b430e399.svg";
export { ForwardRef as ReactComponent };